export default "__VITE_ASSET__Cj3BZll8__"